import { useAppStore } from '@/store/useAppStore.ts'
import { RangeSlider } from 'calc-controls'
import { Badge } from '@/components/shared/Badge.tsx'
import { getChemistryPreset } from '@brt/shared-logic'
import { HelpIcon } from '@/components/shared/HelpIcon.tsx'

export function DoDInput() {
  const dod = useAppStore((s) => s.battery.dod)
  const chemistry = useAppStore((s) => s.battery.chemistry)
  const updateBattery = useAppStore((s) => s.updateBattery)

  const preset = getChemistryPreset(chemistry)
  const dodPercent = Math.round(dod * 100)
  const maxDodPercent = Math.round(preset.maxDoD * 100)
  const exceedsMax = dodPercent > maxDodPercent

  return (
    <div className="dod-input">
      <HelpIcon text="Fraction of rated capacity used per discharge cycle. Lower DoD extends cycle life at the cost of usable energy.">
        <span className="dod-input__label">Depth of Discharge</span>
      </HelpIcon>
      <RangeSlider
        label="Depth of Discharge"
        value={dodPercent}
        onChange={(v) => updateBattery('dod', v / 100)}
        min={0}
        max={100}
        step={1}
        decimals={0}
        unit="%"
      />
      <div className="dod-input__info">
        <span className="dod-input__max">
          Max recommended: {maxDodPercent}%
        </span>
        {exceedsMax && (
          <Badge variant="warning">Exceeds {chemistry} limit</Badge>
        )}
      </div>
    </div>
  )
}
